import { usePrefersReducedMotion } from '@mc/hooks'
import { HeroVideo } from '../HeroVideo'
import { HPQuiz } from './HomepageQuiz'
import styles from './Variant2HPQuiz.module.scss'

export const Variant2HPQuiz = () => {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <HPQuiz />
      </div>

      <div className={styles.desktopGradientOverlay} />
      <div className={styles.mobileGradientOverlay} />

      <HeroVideo
        className={styles.video}
        prefersReducedMotion={prefersReducedMotion}
      />
    </div>
  )
}
